import { render } from "./PaymentIcon.vue?vue&type=template&id=5f22c407&scoped=true"
import script from "./PaymentIcon.vue?vue&type=script&lang=js"
export * from "./PaymentIcon.vue?vue&type=script&lang=js"

import "./PaymentIcon.vue?vue&type=style&index=0&id=5f22c407&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f22c407"]])

export default __exports__